/* import __COLOCATED_TEMPLATE__ from './sq-input-select.hbs.js'; */
var _dec, _class;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { classNames } from '@ember-decorators/component';
/**
## Input Select
`sq-input-select` is a super old `<select>` component that is now borderline deprecated. All it does is render an `sq-field-select` using
the Bridgeport-era hella old form styles. You probably should just use `sq-field-select` directly, and pass it `includeBaseStyling=false`
if for some reason you don't want the "field" styling.

See `sq-field-select` for accepted parameters, since all this does is pass the exact sme params down.
 */

import Component from '@ember/component';
let SqInputSelect = (_dec = classNames('sq-input-select'), _dec(_class = class SqInputSelect extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "optionValuePath", 'value');
    _defineProperty(this, "optionLabelPath", 'label');
    _defineProperty(this, "optionDisabledPath", 'disabled');
    _defineProperty(this, "disabled", false);
    _defineProperty(this, "useOptionsAsValues", false);
    _defineProperty(this, "enablePromptSelection", false);
    _defineProperty(this, "value", null);
    _defineProperty(this, "isInvalid", false);
  }
}) || _class);
export { SqInputSelect as default };